import React from 'react';

import { useCheckoutContext } from '../context/useCheckoutContext';

import CheckoutModalContent from '../components/CheckoutModalContent';
import LinkButton from '../../../../components/buttons/LinkButton';
import ModalBackButton from '../../../../components/modal/ModalBackButton';

import './CheckoutErrorModal.scss';
import { useTranslator } from "../../../../components/i18n/useTranslator";

type CheckoutErrorModalProps = {
    error: string;
};

const CheckoutErrorModal = ({ error }: CheckoutErrorModalProps) => {
    const { dispatchOpenIntercomMessages } = useCheckoutContext();
    const translate = useTranslator('checkout', 'error');

    const backButtonText = translate("backButtonText");

    return (
        <CheckoutModalContent
            className="CheckoutErrorModal"
            header={
                <>
                    <ModalBackButton title={backButtonText} />
                    <h1>
                        {translate('title')}
                    </h1>
                </>
            }
        >
            <p className="error-message">{error}</p>
            <p className="support-message">
                {
                    translate('description')
                }
                &nbsp;
                <LinkButton onClick={dispatchOpenIntercomMessages}>
                    {translate('contactSupportText')}
                </LinkButton>
            </p>
        </CheckoutModalContent>
    );
};

export default CheckoutErrorModal;
